import { formatValue } from 'react-currency-input-field';
import dayjs from 'dayjs';
import { compress, decompress } from 'shrink-string';
import Swal from 'sweetalert2';

const { cryptr_decrypt, cryptr_encrypt } = require("../controllers/commons/encrypt/encrypt");
const jwt = require("jsonwebtoken");


const loadAuth = () => {
  let encrypt_token = cryptr_encrypt().encrypt(
    JSON.stringify({ api: process.env.REACT_APP_API_KEY, expiresAt: dayjs().add(parseInt(process.env.REACT_APP_JWT_EXPIRES_IN),'m').unix() })
  )
  return encrypt_token
};

/**
 * Check is value is null, undefined or empty string
  @param {String} s Tester value.
  @returns {boolean} true/false
*/
const IsNotNull = (s) => {
  return s ? true : false
}

/**
 * Check is value is null, undefined or empty string
  @param {Array} s Tester value.
  @returns {boolean} true/false
*/
const IsEmptyArray = (arr) => {
  let rs = true
  if (IsNotNull(arr) && Array.isArray(arr)) {
    rs = arr.length <= 0 ? true : false
  }
  return rs
}

/**
 * Check is pattern is matching
  @param {String} v Tester value.
  @param {String} regexp Tester value.
  @returns {boolean} true/false
*/
const patternCheck = (v, regexp) => {
  return regexp.test(v);
}

const str2ab = (str) => {
  let buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
  let bufView = new Uint16Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

/**
 * Get Formatted Price
  @param {String} price value.
  @param {String} symbol symbol.
  @param {String} group grouping symbol.
  @param {String} decimal decimal symbol.
  @returns {String} Formatted String Price
*/
const getFormattedPrice = (price, symbol, group, decimal) => {
  let rs = formatValue({
    value: IsNotNull(price) ? price.toString() : '0',
    groupSeparator: group,
    decimalSeparator: decimal,
    prefix: symbol,
  });
  return rs;
}

/**
 * Get Formatted Number
  @param {String} num value.
  @param {String} group grouping symbol.
  @param {String} decimal decimal symbol.
  @returns {String} Formatted String Number
*/
const getFormattedNumber = (num, group, decimal, prefix, suffix) => {
  let rs = formatValue({
    value: IsNotNull(num) ? num.toString() : '0',
    groupSeparator: IsNotNull(group) ? group : '',
    decimalSeparator: IsNotNull(decimal) ? decimal : '',
    prefix: IsNotNull(prefix) ? prefix : '',
    suffix: IsNotNull(suffix) ? suffix : ''
  })
  return rs;
}

/**
 * Mapping options 
  @param {root} troot this.
  @param {Array} data options array from db.
  @param {String} data placeholder.

  @param {State} st_opt state options.
  @param {String} f1 db col id.
  @param {String} f2 db col name.
  @param {boolean} cmb combine t/f.
  @param {String} c1 db col.
  @param {String} c2 db col.
  @param {String} dlm delimeter.

  @returns {String} Formatted String Number
*/
const MappingOptions = async (troot, data, ph, st_opt, f1, f2, cmb, c1, c2, dlm) => {
  if (IsNotNull(data)) {
    let g = [];
    let delimeter = IsNotNull(dlm) ? dlm : '-'
    data.map(x => { g.push({ label: IsNotNull(cmb) ? cmb ? `${x[c1]} ${delimeter} ${x[c2]}` : x[f2] : x[f2], value: x[f1], o: x }) })
    const options = [{ label: ph, options: g }]
    await troot.setState({ [st_opt]: options })
  }
}

const MappingWNullOptions = async (troot, data, ph, st_opt, f1, f2, cmb, c1, c2) => {
  if (IsNotNull(data)) {
    let g = [{ label: 'None', value: null, o: null }];
    await data.map(x => { g.push({ label: IsNotNull(cmb) ? cmb ? `${x[c1]} - ${x[c2]}` : x[f2] : x[f2], value: x[f1], o: x }) })
    const options = [{ label: ph, options: g }]
    await troot.setState({ [st_opt]: options })
  }
}

const MappingWNullOptionsFComp = async (setFunc, data, ph, f1, f2, cmb, c1, c2) => {
  if (IsNotNull(data)) {
    let g = [{ label: 'None', value: null, o: null }];
    await data.map(x => { g.push({ label: IsNotNull(cmb) ? cmb ? `${x[c1]} - ${x[c2]}` : x[f2] : x[f2], value: x[f1], o: x }) })
    const options = [{ label: ph, options: g }]
    setFunc(options)
    // await troot.setState({ [st_opt]: options })
  }
}

/*
    Untuk cek sebelum submit
    troot: this
    rs: result var
    st1: state
    ss: state style
    erm: error message
    type: tipe input text or select or date (v/s/d)
  */
// const checkValue = async (troot, rs, st1, ss, erm, type, tnotif) => {
//   if (!IsNotNull(st1)) {
//     rs = false;
//     if (type === "v") {
//       await troot.setState({ [ss]: "form-control-err" })
//     } else if (type === "s") {
//       await troot.setState({ [ss]: "form-select-err" })
//     } else if (type === "d") {
//       await troot.setState({ [ss]: "form-control-dd-err" })
//     }
//     IsNotNull(tnotif) ? tnotif(IsNotNull(erm) ? erm : 'Error', { variant: "error", autoHideDuration: 1200 }) : null
//   }
//   if (troot.state[ss].includes("err")) {
//     rs = false;
//   }
//   return rs
// }


/*
  troot: this
  find_value: find value
  st_opt: state options
  st: state name to set
*/
const FindSetOption = async (troot, find_value, st_opt, st) => {
  let s = troot.state[st];
  let rs = IsNotNull(find_value) ? await st_opt.options.find(option => option.value === find_value) : null
  s = IsNotNull(rs) ? { ...rs } : { label: "", value: null, o: null }
  await troot.setState({ [st]: s })
}

const FindSetOption2 = async (find_value, st_opt, st) => {
  let s = { label: "", value: null, o: null };
  let rs = IsNotNull(find_value) ? await st_opt.options.find(option => option.value === find_value) : null

  s = IsNotNull(rs) ? { ...rs } : { label: "", value: null, o: null }
  st = s
  // return s
}

const FindSetOptionWKey = async (troot, find_value, st_opt, st, key) => {
  let s = troot.state[st];
  let rs = IsNotNull(find_value) ? await st_opt.options.find(option => option[key] === find_value) : null
  s = IsNotNull(rs) ? { ...rs } : { label: "", value: null, o: null }
  await troot.setState({ [st]: s })
}

const FindOption = (find_value, st_opt) => {
  return IsNotNull(find_value) && IsNotNull(st_opt) ? st_opt.options.find(option => option.value === find_value) : ''
}

/*
  value: this
  has_dec: has decimal
  dec: max decimal
*/
const toFloat = (value, has_dec, dec) => {
  let tmp_val = IsNotNull(value) ? value : 0
  let rs = 0
  rs = parseFloat(has_dec ? parseFloat(tmp_val.toString().replace(/,/g, '.')).toFixed(dec) : tmp_val.toString().replace(/,/g, '.'))
  return rs
}


/*
for check isnotnull or return default
  value: check value
  def: default value
*/
const INNRD = (value, def) => {
  return IsNotNull(value) ? value : def
}

/**
 * Mapping options 
  @param {any} value value to check .
  @param {any} def default return.
  @param {String} format format pattern for dayjs.
  return string date
*/
const INNDRD = (value, def, format) => {
  let dformat = IsNotNull(format) ? format : 'DD-MMMM-YYYY HH:mm:ss'
  return IsNotNull(value) ? dayjs(value).format(dformat) : def
}

/**
  @property {props} props JSON = {title,subTitle}
  @param {String} file_name file name to save.
  @param {String} file_type file type.
*/
const notifBeforeAct = async (props) => {
  let rs = false
  await Swal.fire({
    title: IsNotNull(props.title) ? props.title : 'Are you sure?',
    text: IsNotNull(props.subTitle) ? props.subTitle : "You won't be able to revert this!",
    icon: "warning",
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    showCancelButton: true,
    confirmButtonText: IsNotNull(props.confirmButtonText) ? props.confirmButtonText : 'Yes',
    denyButtonText: `Cancel`,
    animation: true
  }).then(async (result) => {
    if (result.isConfirmed) {
      rs = true
    }
  });
  return rs
}

/**
  @param {JSON} b parameters.
  @param {String} url url.
*/
const DeleteData = async (b, url) => {
  let result = { code: 'D-00', status: false, message: '' }
  try {
    await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: loadAuth(),
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'cfl',
      }, body: JSON.stringify({
        p1: b.p1
      }),
    })
      .then(response => response.json())
      .then(x => {
        result = x;
      });
  } catch (e) {
    result = { code: 'EC-00', status: false, message: 'Error on Controller' }
  } finally {
    return result
  }
}

/**
  @param {JSON} b parameters.
  @param {String} url url.
*/
const DeleteDataWBody = async (b, url) => {
  let result = { code: 'D-00', status: false, message: '' }
  try {
    b.update_by = 'system'
    await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: loadAuth(),
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'cfl',
      }, body: JSON.stringify({
        data: cryptr_encrypt().encrypt(JSON.stringify(b))
      }),
    })
      .then(response => response.json())
      .then(x => {
        result = x;
      });
  } catch (e) {
    result = { code: 'EC-00', status: false, message: 'Error on Controller' }
  } finally {
    return result
  }
}

/**
  @param {String} url url.
*/
const GetOptData = async (url) => {
  let result = null
  try {
    await fetch(url, {
      method: "GET",
      headers: {
        Authorization: loadAuth(),
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'cfl',
      }
    })
      .then(response => response.json())
      .then(async x => {
        if (x.code === "GD-01") {
          let decompressed = await decompress(x.token)
          const decrypted = cryptr_decrypt().decrypt(decompressed);
          result = JSON.parse(decrypted).data;
        }
        // if (x.code === "GD-01") {
        //   let decompressed = await decompress(x.token)
        //   const decrypted = cryptr_decrypt().decrypt(decompressed);
        //   const rs_d = jwt.decode(decrypted);
        //   result = rs_d.data;
        // }
      });
  } catch (e) {
    result = null
  } finally {
    return result;
  }
}

/**
 * get options with body
  @param {String} url url.
  @param {JSON} b json.
*/
const GetOptWBody = async (b, url) => {
  let result = null
  try {
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: loadAuth(),
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'cfl',
      }, body: JSON.stringify({
        p1: cryptr_encrypt().encrypt(JSON.stringify(b))
      }),
    })
      .then(response => response.json())
      .then(async x => {
        if (x.code === "GD-01") {
          let decompressed = await decompress(x.token)
          const decrypted = cryptr_decrypt().decrypt(decompressed);
          const rs_d = jwt.decode(decrypted);
          result = rs_d.data;
        }
      });
  } catch (e) {
    result = null
  } finally {
    return result;
  }
}

/**
  @param {String} url url.
  @param {JSON} b JSON parameter .
*/
const GetOptData1P = async (b, url) => {
  let result = null
  try {
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: loadAuth(),
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'cfl',
      }, body: JSON.stringify(b),
    })
      .then(response => response.json())
      .then(async x => {
        if (x.code === "GD-01") {
          let decompressed = await decompress(x.token)
          const decrypted = cryptr_decrypt().decrypt(decompressed);
          const rs_d = jwt.decode(decrypted);
          result = rs_d.data;
        }
      });
  } catch (e) {
    result = null
  } finally {
    return result;
  }
}


/**
  @param {JSON} b parameters.
  @param {String} url url.
*/
const UpdateData = async (b, url) => {
  let result = { code: 'U-00', status: false, message: '' };
  try {
    b.update_by = 'system'
    await fetch(url, {
      method: "PATCH",
      headers: {
        Authorization: loadAuth(),
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'cfl',
      }, body: JSON.stringify({
        data: cryptr_encrypt().encrypt(JSON.stringify(b))
      }),
    })
      .then(response => response.json())
      .then(x => {
        result = x;
      })

  } catch (e) {
    result = { code: 'EC-00', status: false, message: 'Error on Controller' }
  } finally {
    return result;
  }
}

const GetData = async (b, url) => {
  let result = null;
  try {
    let enc = cryptr_encrypt().encrypt(JSON.stringify(b))
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: loadAuth(),
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'cfl',
      }, body: JSON.stringify({
        p1: enc
      }),
    })
      .then(response => response.json())
      .then(async x => {
        if (x.code === "GD-01") {
          let decompressed = await decompress(x.token)
          const decrypted = cryptr_decrypt().decrypt(decompressed);
          result = JSON.parse(decrypted).data;
        }
      });
  } catch (e) {
    result = null;
  } finally {
    return result;
  }
}

const CreateData = async (b, url) => {
  let result = { code: 'C-00', status: false, message: '' };
  try {
    b.created_by = 'system'
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: loadAuth(),
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'cfl',
      }, body: JSON.stringify({
        data: cryptr_encrypt().encrypt(JSON.stringify(b))
      }),
    })
      .then(response => response.json())
      .then(x => { result = x });
  } catch (e) {
    result = { code: 'EC-00', status: false, message: 'Error on Controller' }
  } finally {
    return result;
  }
}

const getLeaveRequestTypeValue = (x) => {
  let rs = ''
  if (IsNotNull(x)) {
    let data_status = [
      { id: 1, value: "Cuti Tahunan" },
      { id: 2, value: "Izin Sakit" },
      { id: 3, value: "Izin Kedinasan" },
      { id: 98, value: "Izin Terlambat" },
      { id: 99, value: "Izin Pulang Awal" },
      { id: 100, value: "Izin Lainnya" },
    ]
    let f = data_status.find(l => l.id === x)
    if (IsNotNull(f)) {
      rs = f.value
    }
  }
  return rs;
}

/**
  @param {Array Object} x result from fetch.
  @param {Function} funcSuccess function to show up alert when success create.
  @param {Function} funcError function to show up alert when error create.
  @param {String} title state name title.
  @param {String} desc state name description.
*/
const checkApproveResult = async ({ x, title, titleErr, desc, descErr, funcSuccess, funcError }) => {
  switch (x.code) {
    case "U-01":
      Swal.fire({
        title: IsNotNull(title) ? title : 'Approve Success',
        text: IsNotNull(desc) ? desc : '',
        icon: "success",
        draggable: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK"
      }).then((result) => {
        if (result.isConfirmed) {
          if(IsNotNull(funcSuccess)){
            funcSuccess()
          }
          // IsNotNull(funcSuccess) ? funcSuccess() : null
        }
      });
      break;
    default:
      Swal.fire({
        title: IsNotNull(titleErr) ? titleErr : 'Approve Failed',
        text: IsNotNull(descErr) ? descErr : x.message,
        icon: "error",
        draggable: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK"
      }).then((result) => {
        if (result.isConfirmed) {
          if(IsNotNull(funcError)){
            funcError()
          }
          // IsNotNull(funcError) ? funcError() : null
        }
      });
      break;
  }
}

/**
  @param {Array Object} x result from fetch.
  @param {Function} funcSuccess function to show up alert when success create.
  @param {Function} funcError function to show up alert when error create.
  @param {String} title state name title.
  @param {String} desc state name description.
*/
const checkRejectResult = async ({ x, title, titleErr, desc, descErr, funcSuccess, funcError }) => {
  switch (x.code) {
    case "U-01":
      Swal.fire({
        title: IsNotNull(title) ? title : 'Reject Success',
        text: IsNotNull(desc) ? desc : '',
        icon: "success",
        draggable: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK"
      }).then((result) => {
        if (result.isConfirmed) {
          if(IsNotNull(funcSuccess)){
            funcSuccess()
          }
          // IsNotNull(funcSuccess) ? funcSuccess() : null
        }
      });
      break;
    default:
      Swal.fire({
        title: IsNotNull(titleErr) ? titleErr : 'Reject Failed',
        text: IsNotNull(descErr) ? descErr : x.message,
        icon: "error",
        draggable: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK"
      }).then((result) => {
        if (result.isConfirmed) {
          if(IsNotNull(funcError)){
            funcError()
          }
          // IsNotNull(funcError) ? funcError() : null
        }
      });
      break;
  }
}

const GetBlob = async (b, url) => {
  // let result = { code: 'U-00', status: false, message: '' };
  // try {
  //   b.update_by = 'system'
  //   await fetch(url, {
  //     method: "PATCH",
  //     headers: {
  //       Authorization: loadAuth(),
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       AppMode: 'cfl',
  //     }, body: JSON.stringify({
  //       data: cryptr_encrypt().encrypt(JSON.stringify(b))
  //     }),
  //   })
  //     .then(response => response.json())
  //     .then(x => {
  //       result = x;
  //     })

  // } catch (e) {
  //   result = { code: 'EC-00', status: false, message: 'Error on Controller' }
  // } finally {
  //   return result;
  // }

  let result = null;
  try {
    let enc = cryptr_encrypt().encrypt(JSON.stringify(b))
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: loadAuth(),
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'cfl',
      }, body: JSON.stringify({
        p1: enc
      }),
    })
      .then(response => response.blob())
      .then(async x => {
        result = x
      });
  } catch (e) {
    result = null
  } finally {
    return result;
  }

}

/**
  @param {blob} blob A blob data.
  @param {String} file_name file name.
  @param {String} file_type file type.
*/
const openFileNewTab = (blob, file_name, file_type) => {
  try {
    if (IsNotNull(blob)) {
      file_name = IsNotNull(file_name) ? file_name : 'file'
      file_type = IsNotNull(file_type) ? file_type : 'application/pdf'
      const file = new File([blob], file_name, { type: file_type });
      window.open(URL.createObjectURL(file), '_blank');
    }
  } catch (error) {
    console.log('Open File Failed');
  }
}


export {
  IsNotNull,
  patternCheck,
  // checkValue,
  getFormattedPrice,
  getFormattedNumber,
  MappingOptions,
  FindSetOption,
  toFloat,
  INNRD,
  str2ab,
  FindOption,
  MappingWNullOptions,
  FindSetOptionWKey,
  INNDRD,
  DeleteData,
  DeleteDataWBody,
  GetOptData,
  UpdateData,
  CreateData,
  GetOptData1P,
  GetData,
  MappingWNullOptionsFComp,
  FindSetOption2,
  IsEmptyArray,
  notifBeforeAct,
  GetOptWBody,
  getLeaveRequestTypeValue,
  checkApproveResult,
  checkRejectResult,
  openFileNewTab,
  GetBlob
  // getBadgeLeaveRequestStatus
}